import { render } from "./the-sidebar.vue?vue&type=template&id=cdb8ae6e&scoped=true"
import script from "./the-sidebar.vue?vue&type=script&lang=js"
export * from "./the-sidebar.vue?vue&type=script&lang=js"

import "./the-sidebar.vue?vue&type=style&index=0&id=cdb8ae6e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdb8ae6e"]])

export default __exports__